import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export type PatchExerciseEventDocumentsPayload = {
  additionalNotes: string;
  companyId: string;
  eventId: string;
  filesLinks: string[];
};

export const usePatchExerciseEventDocuments = () => {
  const { isPending, mutate } = useIdempotentAppMutation(
    [QueryKey.PATCH_EXERCISE_EVENT_DOCUMENTS],
    {
      mutationFn: (
        { companyId, eventId, ...body }: PatchExerciseEventDocumentsPayload,
        { headers },
      ) =>
        ApiService.patch(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'events', eventId, 'documents'],
          },
          { body, headers },
        ),
    },
  );

  return { isPending, patchExerciseEventDocuments: mutate };
};
